import { sanitizeRichHtml } from "./sanitize";

export function RichTextView({ html }: { html: string }) {
  return <div className="rich-text" dangerouslySetInnerHTML={{ __html: sanitizeRichHtml(html) }} />;
}
